import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ComposerEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import PageStack from '../../../moreCore/UI/Tabbing/PageStack';
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import Edit from '../../../moreCore/UI/Edit/Edit';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import lang from 'dojo/_base/lang';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { EntityExistCheck } from "../../_loadingHelpers/VAMv2";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import Button from '../../../moreCore/UI/Button/Button';
import Tooltip from '../../../moreCore/UI/Floating/Tooltip';
import AddressView from '../../AddressFinder/AddressView';

class ComposerEditor extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private pagestack: MdsLax<InstanceType<typeof PageStack>>;
    private addressHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private pseudonymEdit: MdsLax<InstanceType<typeof Edit>>;

    private salutationSelect: MdsLax<InstanceType<typeof SearchSelect>>;
    private firstnameEdit: MdsLax<InstanceType<typeof Edit>>;
    private lastnameEdit: MdsLax<InstanceType<typeof Edit>>;

    private birthDatepicker: MdsLax<InstanceType<typeof DateInput>>;
    private nc_birthDatepicker: MdsLax<InstanceType<typeof DateInput>>;
    private birthEdit: MdsLax<InstanceType<typeof Edit>>;
    private nc_birthEdit: MdsLax<InstanceType<typeof Edit>>;
    private deathDatepicker: MdsLax<InstanceType<typeof DateInput>>;
    private nc_deathDatepicker: MdsLax<InstanceType<typeof DateInput>>;
    private deathEdit: MdsLax<InstanceType<typeof Edit>>;
    private nc_deathEdit: MdsLax<InstanceType<typeof Edit>>;

    private addressHintboxSection: HTMLDivElement;
    private entityExistCheck: MdsLax<InstanceType<typeof EntityExistCheck>>;

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this.pagestack.disablePage("newComposer");
        this.pagestack.enablePage("existingAddress");

        let address = this.getAttributeValue("___root");
        this.addressHintbox.setValue(address, true);
        this.addressHintbox.setReadonly(true);

        let pseudonym = this.getAttributeValue("pseudonym");
        this.pseudonymEdit.setValue(pseudonym, true);

        let dateBirth = this.getAttributeValue("day_of_birth");
        this.birthDatepicker.setValue(dateBirth, false);
        let dateBirthText = this.getAttributeValue("born");
        this.birthEdit.setValue(dateBirthText, false);

        let dateDeath = this.getAttributeValue("day_of_death");
        this.deathDatepicker.setValue(dateDeath, false);
        let dateDeathText = this.getAttributeValue("died");
        this.deathEdit.setValue(dateDeathText, false);
    }

    private _onChangeBirthText(type: string, e: string) {
        switch (type) {
            case "existingAddress":
                //this.nc_birthEdit.setValue(e, true);
                if (e) this.birthDatepicker.setReadonly(true);
                else this.birthDatepicker.setReadonly(false);
                break;
            case "newComposer":
                //this.birthEdit.setValue(e, true);
                if (e) this.nc_birthDatepicker.setReadonly(true);
                else this.nc_birthDatepicker.setReadonly(false);
                break;
        }

        this.setAttributeValue("born", e);
    }

    private _onChangeDeathText(type: string, e: string) {
        switch (type) {
            case "existingAddress":
                //this.nc_deathEdit.setValue(e, true);
                if (e) this.deathDatepicker.setReadonly(true);
                else this.deathDatepicker.setReadonly(false);
                break;
            case "newComposer":
                //this.deathEdit.setValue(e, true);
                if (e) this.nc_deathDatepicker.setReadonly(true);
                else this.nc_deathDatepicker.setReadonly(false);
                break;
        }

        this.setAttributeValue("died", e);
    }

    private _onChangeBirthDate(type: string, e) {
        let newDate;
        switch (type) {
            case "existingAddress":
                newDate = this.birthDatepicker.getValue();
                if (newDate) this.birthEdit.setReadonly(true);
                else this.birthEdit.setReadonly(false);
                //this.nc_birthDatepicker.setValue(newDate, true);
                break;
            case "newComposer":
                newDate = this.nc_birthDatepicker.getValue();
                if (newDate) this.nc_birthEdit.setReadonly(true);
                else this.nc_birthEdit.setReadonly(false);
                //this.birthDatepicker.setValue(newDate, true);
                break;
        }

        this.setAttributeValue("day_of_birth", newDate);
    }

    private _onChangeDeathDate(type: string, e) {
        let newDate;
        switch (type) {
            case "existingAddress":
                newDate = this.deathDatepicker.getValue();
                if (newDate) this.deathEdit.setReadonly(true);
                else this.deathEdit.setReadonly(false);
                //this.nc_deathDatepicker.setValue(newDate, true);
                break;
            case "newComposer":
                newDate = this.nc_deathDatepicker.getValue();
                if (newDate) this.nc_deathEdit.setReadonly(true);
                else this.nc_deathEdit.setReadonly(false);
                //this.deathDatepicker.setValue(newDate, true);
                break;
        }
        this.setAttributeValue("day_of_death", newDate);
    }

    private _onChangeEdit(type: string, e: string) {
        this.setAttributeValue(type, e);

        switch (type) {
            case "name":
            case "name_first":

                let name = this.getAttributeValue("name");
                if (name) {
                    let name_first = this.getAttributeValue("name_first");
                    let attributes = {
                        name: name,
                        name_first: name_first
                    }
                    this.entityExistCheck.requestCheck("composer", attributes);
                }
                break;
        }
    }

    private _entityExistCallback(row: StaticTable.StaticTableRow<any>, rowGroup: StaticTable.StaticTableRowGroup<any>) {

        this.emit("RequestNewEditorInstance", rowGroup.entity);
        this.closeTab();
    }

    private _onChangeSelect(e) {
        let newSalutation = this.salutationSelect.getValue(true);
        this.setAttributeValue("ref_salutation", newSalutation);
    }

    private _onChangeHintbox(e) {
        let newPerson = this.addressHintbox.getValue("entity");
        this.setData(newPerson);

        let pseudonym = this.getAttributeValue("pseudonym");
        this.pseudonymEdit.setValue(pseudonym, true);

        let dateBirth = this.getAttributeValue("day_of_birth");
        this.birthDatepicker.setValue(dateBirth, false);
        let dateBirthText = this.getAttributeValue("born");
        this.birthEdit.setValue(dateBirthText, true);

        let dateDeath = this.getAttributeValue("day_of_death");
        this.deathDatepicker.setValue(dateDeath, true);
        let dateDeathText = this.getAttributeValue("died");
        this.deathEdit.setValue(dateDeathText, true);
    }

    isValid(): boolean {
        //Need to implement
        let page = this.pagestack.getActivePageName();

        switch (page) {
            case "newComposer":
                if (!this.salutationSelect.getValue()) return false;
                if (!this.firstnameEdit.getValue()) return false;
                if (!this.lastnameEdit.getValue()) return false;
                if (!this.entityExistCheck.isValid()) return false;
                break;
        }
        return true;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.Composers;
    }

    private _onClickSEDButton(mode: string, e) {
        this.loadSelectEntityDialog(e, mode, lang.hitch(this, this._onSEDCallback));
    }

    private _onSEDCallback(mode: string, data, items) {
        if (items.length > 0) {
            let newPerson = items[0].entry.data;
            this.addressHintbox.setValue(newPerson);
        }
    }

    private createAdressEntityViewButton() {

        if (!this.hasUserRole("Addresses_Read")) return;

        let btn = new Button();

        btn.setup({
            parentNode: this.addressHintboxSection,
            //disabledClasses: "moreCoreButton buttonBase secondaryBG",
            //enabledClasses: "mds-button-base primaryBG padding",
            styleClass: "mds-button-base primaryBG padding hoverBright",
            iconClass: "fas fa-address-card",
            callback: () => {
                let view = new AddressView();

                view.showAsDlg(this.entityId, this.getAttributeValue("gDisp_1"), this.getTabContainerName());

                view.on("change", lang.hitch(this, this.loadEntity, this.entityId));
                view.on("deleted", lang.hitch(this, this.close));
            }
        })
        this.UiModder.domClass.remove(btn.domNode, "buttonBase");

        let tooltip = new Tooltip();
        tooltip.setup({
            content: this.translate("AddressView_Tooltip_ShowAddressView"),
            targetnode: btn.domNode,
            delayMS: 200
        })
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (this.isNew) {
            this.pagestack.enablePage("newComposer");
            this.pagestack.disablePage("existingAddress");
        }

        //this.SEDconfigCallfunction = "Webtool_API_Composers__SED_GetConfig";
        //this.addressHintbox.addInlineButton(lang.hitch(this, this._onClickSEDButton, "selectPerson"));

        this.birthEdit.on("change", lang.hitch(this, this._onChangeBirthText, "existingAddress"));
        this.nc_birthEdit.on("change", lang.hitch(this, this._onChangeBirthText, "newComposer"));
        this.deathEdit.on("change", lang.hitch(this, this._onChangeDeathText, "existingAddress"));
        this.nc_deathEdit.on("change", lang.hitch(this, this._onChangeDeathText, "newComposer"));
        this.birthDatepicker.on("change", lang.hitch(this, this._onChangeBirthDate, "existingAddress"));
        this.nc_birthDatepicker.on("change", lang.hitch(this, this._onChangeBirthDate, "newComposer"));
        this.deathDatepicker.on("change", lang.hitch(this, this._onChangeDeathDate, "existingAddress"));
        this.nc_deathDatepicker.on("change", lang.hitch(this, this._onChangeDeathDate, "newComposer"));
        this.salutationSelect.on("change", lang.hitch(this, this._onChangeSelect));
        this.firstnameEdit.on("change", lang.hitch(this, this._onChangeEdit, "name_first"));
        this.lastnameEdit.on("change", lang.hitch(this, this._onChangeEdit, "name"));
        //this.addressHintbox.on("change", lang.hitch(this, this._onChangeHintbox));

        this.entityExistCheck.setup({
            operationMode: "open",
            requestValidation: true,
            validWhenFound: false,
            entityListRowClickEnabled: true,
            entityListTableRowClickCallback: lang.hitch(this, this._entityExistCallback),
            listDlgSubtitle: this.translate("EntityExistCheck_FounEntriesList_Sub")
        })
        this.createAdressEntityViewButton();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ComposerEditor);
